<template>
  <div :class="{ 'header-container': true, 'header-transparent': !isScrolled, 'header-white': isScrolled }"
    style="width: 100%; position: fixed; top: 0; z-index: 9999;">
    <header class="header-nav home">
      <router-link to="/home" active-class="active" class="logo">
        <img src="@/assets/logo.png" alt="熊猫在学logo">
      </router-link>
      <nav class="nav-menu">
        <ul>
          <li class="homePage"><router-link to="/home" active-class="active">首页</router-link></li>
          <li><router-link to="/course" active-class="active">课程</router-link></li>
          <li><router-link to="/membership" active-class="active">会员</router-link></li>
          <li><router-link to="/about" active-class="active">关于</router-link></li>
        </ul>
      </nav>
      <div class="download-app" v-show="isShow">
        <router-link to="/download">下载APP</router-link>
      </div>
    </header>
  </div>

</template>

<script>

export default {
  name: 'HeaderNav',
  data() {
    return {
      isShow: false,
      isScrolled: false
    }
  },
  mounted() {
    this.isShow = !(this.$route.path === '/download')
    // 监听页面滚动事件
    window.addEventListener('scroll', this.handleScroll)
    // 初始化时检查一次滚动状态（避免刷新页面时状态错误）
    this.handleScroll()
  },
  beforeDestroy() {
    // 组件销毁时移除事件监听，避免内存泄漏
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    $route() {
      this.isShow = !(this.$route.path === '/download')
    }
  },
  methods: {
    // 处理滚动事件：判断滚动距离是否超过阈值
    handleScroll() {
      // 当滚动距离 > 50px 时，认为已滚动（阈值可根据需求调整）
      this.isScrolled = window.scrollY > 50
      console.log(window.scrollY)
      console.log(this.isScrolled)
    }
  }
}
</script>

<style scoped>
/* 基础容器样式 */
.header-container {
  /* transition: background-color 0.1s ease; */
  /* 背景色过渡动画 */
}

/* 滚动前：背景透明 */
.header-transparent {
  background-color: transparent;
}

/* 滚动后：背景白色 */
.header-white {
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* 可选：添加阴影增强层次感 */
}

.header-nav {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 82px;
  margin: 0 auto;
  font-family: Source Han Sans SC-Medium;
}

.logo {
  display: flex;
  align-items: center;
}

.logo:hover {
  transform: scale(0.99);
}

.logo img {
  width: 174px;
  height: 52px;
  margin-right: 8px;
}

.nav-menu {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.nav-menu ul {
  font-family: Source Han Sans SC-Medium;
  font-size: 20px;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-menu li {
  margin: 0 20px;
}

.nav-menu a:hover {
  color: #FFA10F;
}

.download-app {
  width: 110px;
  height: 42px;
  font-family: Source Han Sans SC-Regular;
  color: rgba(255, 200, 3, 1);
  font-size: 20px;
  border: 1.5px solid rgba(255, 200, 3, 1);
  border-radius: 14px;
  transition: all 0.3s ease;
  text-align: center;
  line-height: 42px;
}

.download-app:hover {
  color: rgba(255, 161, 15, 1);
  border: 1.5px solid rgba(255, 161, 15, 1);
  transform: scale(0.99);

}

/* 添加激活状态的样式 */
.nav-menu .active {
  color: #FFA10F;
}

/* 移动端样式 (小于768px) */
@media screen and (max-width: 767px) {
  .header-nav {
    height: 60px;
    padding: 0 15px;
  }

  .logo img {
    width: 82px;
    height: 24px;
  }

  .nav-menu ul {
    font-size: 14px;
  }

  .nav-menu li {
    margin: 0 6px;
  }

  .download-app {
    width: 52px;
    height: 20px;
    font-size: 12px;
    line-height: 20px;
  }



  /* .homePage {
    display: none;
  } */
}
</style>
